/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentCapabilitiesControllerListQueryResponse } from "../../models/incidentAgentController/IncidentCapabilitiesControllerList";

function getIncidentCapabilitiesControllerListUrl() {
  const res = { method: 'GET', url: `/api/v1/incident-agent/capabilities` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/capabilities}
 */
export async function incidentCapabilitiesControllerList(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentCapabilitiesControllerListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIncidentCapabilitiesControllerListUrl().url.toString(), ... requestConfig })  
  return res.data
}